function t(a, e) {
  return a + (e === "default" ? "" : e.replace(/^[a-z]/, (r) => r.toUpperCase()));
}
t("abc", "def");
export {
  t as createKey
};
